import { render, staticRenderFns } from "./visitorPerson.vue?vue&type=template&id=7e54550c&scoped=true&"
import script from "./visitorPerson.vue?vue&type=script&lang=js&"
export * from "./visitorPerson.vue?vue&type=script&lang=js&"
import style0 from "./visitorPerson.vue?vue&type=style&index=0&lang=css&"
import style1 from "./visitorPerson.vue?vue&type=style&index=1&id=7e54550c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e54550c",
  null
  
)

export default component.exports